import type { Properties } from '@wix/ambassador-site-properties-service/types';

export class SiteProperties {
  constructor(private readonly properties: Properties | undefined) {}

  get country(): string {
    return this.properties?.locale?.country ?? '';
  }
}
